<template>
  <div id="inboundContainer" class="p-3">
    <!-- Inbound Info Section -->
    <div class="vs-collapse-item--header pointer" @click="toggleSection('inbound-info')">
      <div class="flex items-center">
        <feather-icon icon="HelpCircleIcon" class="mr-2" svgClasses="stroke-current text-white w-5 h-5" />
        <strong class="text-white" v-text="$t('inbound_info')"></strong>
      </div>
      <span class="icon-header vs-collapse-item--icon-header" :class="{ 'rotate-arrow-up': !hideSection.inboundInfo }">
        <i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i>
      </span>
    </div>
    <div class="p-4" :class="['show', { 'hide-section': hideSection.inboundInfo }]">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('phone_number')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
              <span v-text="inboundInfo.phone_number"></span>
            </div>
          </div>
        </div>

        <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('consultant_extension_number')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
              <span v-text="inboundInfo.extension"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('ring_group')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
              <span v-text="inboundInfo.ring_group"></span>
            </div>
          </div>
        </div>

        <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('recent_calls_and_counselors')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
              <div class="text-danger">
                <span v-text="inboundInfo.last_agent.agent_name" v-if="typeof inboundInfo.last_agent.agent_name != 'undefined' && inboundInfo.last_agent.agent_name.length > 0"></span>
                <span v-text="$t('empty')" v-else></span>
                <span v-text="` (${$momentHelper.getDateTime(inboundInfo.last_agent.last_called_date)})`" v-if="typeof inboundInfo.last_agent.last_called_date != 'undefined' && inboundInfo.last_agent.last_called_date.length > 0"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('ivr_staff')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
              <span v-text="inboundInfo.ivr"></span>
            </div>
          </div>
        </div>

        <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('telephone_intake_time')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
              <span v-text="inboundInfo.call_date_time"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Profile Section -->
    <div class="vs-collapse-item--header pointer mt-5" @click="toggleSection('profile')">
      <div class="flex items-center">
        <feather-icon icon="UserIcon" class="mr-2" svgClasses="stroke-current text-white w-5 h-5" />
        <strong class="text-white" v-text="$t('profile')"></strong>
      </div>
      <span class="icon-header vs-collapse-item--icon-header" :class="{ 'rotate-arrow-up': !hideSection.profile }">
          <i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i>
        </span>
    </div>
    <div class="p-4" :class="['show', { 'hide-section': hideSection.profile }]">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('member_name')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
              <vs-input v-model="memberFormData.name" class="w-full"/>
              <validation-error :model-error="memberFormErrors.name"></validation-error>
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('caller_company_name')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
              <vs-input v-model="memberFormData.company_name" class="w-full"/>
              <validation-error :model-error="memberFormErrors.company_name"></validation-error>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('mobile')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
              <vs-input v-model="memberFormData.mobile" class="w-full"/>
              <validation-error :model-error="memberFormErrors.mobile"></validation-error>
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('landline')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
              <vs-input v-model="memberFormData.landline" class="w-full"/>
              <validation-error :model-error="memberFormErrors.landline"></validation-error>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('age')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
              <vs-input v-model="memberFormData.age" class="w-full"/>
              <validation-error :model-error="memberFormErrors.age"></validation-error>
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full" id="member-group-container">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('member_groups')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
<!--              <v-select :options="groupOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="memberFormData.group_id" class="md:mb-0" />-->
              <select v-model="memberFormData.group_id" class="vs-inputx vs-input--input normal md:mb-0">
                <option value="">{{ $t('please_select') }}</option>
                <option v-for="(option, key) in groupOptions" :key="'group_id_' + key" :value="option.value">{{ option.label }}</option>
              </select>
              <validation-error :model-error="memberFormErrors.group_id"></validation-error>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full" id="level-name-container">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('membership_level')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
<!--              <v-select :options="levelOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="memberFormData.level_id" class="md:mb-0" />-->
              <select v-model="memberFormData.level_id" class="vs-inputx vs-input--input normal md:mb-0">
                <option value="">{{ $t('please_select') }}</option>
                <option v-for="(option, key) in levelOptions" :key="'level_id_' + key" :value="option.value">{{ option.label }}</option>
              </select>
              <validation-error :model-error="memberFormErrors.level_id"></validation-error>
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('email')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
              <vs-input v-model="memberFormData.email" class="w-full"/>
              <validation-error :model-error="memberFormErrors.email"></validation-error>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('join_now')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
              <vs-input readonly :value="$momentHelper.getDateTime(memberFormData.created_at)" v-if="typeof memberFormData.created_at != 'undefined' && memberFormData.created_at.length > 0" class="w-full"/>
              <span v-text="$t('empty')" v-else></span>
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('address')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
              <vs-input v-model="memberFormData.address" class="w-full"/>
              <validation-error :model-error="memberFormErrors.address"></validation-error>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div v-for="(memberCustomField, key) in memberCustomFields" v-bind:key="'memberCustomField_' + key" class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="memberCustomField.title"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
              <template v-if="memberCustomField.type == 'Text'">
                <vs-input v-model="memberFormData.custom_fields_form_data[key].value" class="w-full"/>
              </template>

              <template v-if="memberCustomField.type == 'Select'">
<!--                <v-select :options="memberCustomField.options" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="memberFormData.custom_fields_form_data[key].value" class="md:mb-0" />-->
                <select v-model="memberFormData.custom_fields_form_data[key].value" class="vs-inputx vs-input--input normal md:mb-0">
                  <option value="">{{ $t('please_select') }}</option>
                  <option v-for="(option, key) in memberCustomField.options" :key="'member_custom_fields_' + key" :value="option.value">{{ option.label }}</option>
                </select>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <vs-button
            v-if="$store.getters.hasCompanyPermission('company_can_upload_sound_file') && $store.getters.hasPermission('upload_sound_file')"
            class="w-full"
            color="primary"
            type="filled"
            @click.prevent="openSoundFilesPopup(inboundInfo.extension)"
            v-text="$t('play_sound')"
          ></vs-button>
        </div>
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <vs-button class="w-full" color="primary" type="filled"  @click.prevent="register" v-text="$t('enrollment')"></vs-button>
        </div>
      </div>
    </div>

    <!-- Counceling Management Section -->
    <div class="vs-collapse-item--header pointer mt-5" @click="toggleSection('counceling-management')">
      <div class="flex items-center">
        <feather-icon icon="PhoneIcon" class="mr-2" svgClasses="stroke-current text-white w-5 h-5" />
        <strong class="text-white" v-text="$t('counseling_management')"></strong>
      </div>
      <span class="icon-header vs-collapse-item--icon-header" :class="{ 'rotate-arrow-up': !hideSection.councelingManagement }">
          <i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i>
        </span>
    </div>
    <div class="p-4" :class="['show', { 'hide-section': hideSection.councelingManagement }]">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('consultant_name')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
              <vs-input readonly v-model="consultationFormData.name" class="w-full"/>
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('business_person')"></strong>
              <div style="float: right">
                <vs-checkbox v-model="consultationFormData.alarm"></vs-checkbox>
              </div>
            </div>
            <div class="vx-col sm:w-8/12 w-full" id="business-person-container">
<!--              <v-select :options="extensionOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="consultationFormData.assigned_agent_id" class="md:mb-0" />-->
              <select v-model="consultationFormData.assigned_agent_id" class="vs-inputx vs-input--input normal md:mb-0">
                <option value="">{{ $t('please_select') }}</option>
                <option v-for="(option, key) in extensionOptions" :key="'assigned_agent_id_' + key" :value="option.value">{{ option.label }}</option>
              </select>
              <validation-error :model-error="consultationFormErrors.assigned_agent_id"></validation-error>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full" id="classification-container">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('classification')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
<!--              <v-select :options="divisionOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="consultationFormData.division_id" class="md:mb-0" />-->
              <select v-model="consultationFormData.division_id" class="vs-inputx vs-input--input normal md:mb-0">
                <option value="">{{ $t('please_select') }}</option>
                <option v-for="(option, key) in divisionOptions" :key="'division_id_' + key" :value="option.value">{{ option.label }}</option>
              </select>
              <validation-error :model-error="consultationFormErrors.division_id"></validation-error>
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full" id="treatment-result-container">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('treatment_result')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
<!--              <v-select :options="resultOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="consultationFormData.result_type_id" class="md:mb-0" />-->
              <select v-model="consultationFormData.result_type_id" class="vs-inputx vs-input--input normal md:mb-0">
                <option value="">{{ $t('please_select') }}</option>
                <option v-for="(option, key) in resultOptions" :key="'result_type_id_' + key" :value="option.value">{{ option.label }}</option>
              </select>
              <validation-error :model-error="consultationFormErrors.result_type_id"></validation-error>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full" id="big-container">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('big')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
<!--              <v-select :options="bigOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="consultationFormData.big_type_id" class="md:mb-0" />-->
              <select v-model="consultationFormData.big_type_id" class="vs-inputx vs-input--input normal md:mb-0">
                <option value="">{{ $t('please_select') }}</option>
                <option v-for="(option, key) in bigOptions" :key="'big_type_id_' + key" :value="option.value">{{ option.label }}</option>
              </select>
              <validation-error :model-error="consultationFormErrors.big_type_id"></validation-error>
            </div>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full" id="middle-class-container">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="$t('middle_class')"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
<!--              <v-select :options="smallOptions" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="consultationFormData.small_type_id" class="md:mb-0" />-->
              <select v-model="consultationFormData.small_type_id" class="vs-inputx vs-input--input normal md:mb-0">
                <option value="">{{ $t('please_select') }}</option>
                <option v-for="(option, key) in smallOptions" :key="'small_type_id_' + key" :value="option.value">{{ option.label }}</option>
              </select>
              <validation-error :model-error="consultationFormErrors.small_type_id"></validation-error>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div v-for="(consultationCustomField, key) in consultationCustomFields" v-bind:key="'consultationCustomField_' + key" class="vx-col sm:w-1/2 md:w-1/2 w-full">
          <div class="vx-row align-center mb-3">
            <div class="vx-col sm:w-4/12 w-full">
              <strong v-text="consultationCustomField.title"></strong>
            </div>
            <div class="vx-col sm:w-8/12 w-full">
              <template v-if="consultationCustomField.type == 'Text'">
                <vs-input v-model="consultationFormData.custom_fields_form_data[key].value" class="w-full"/>
              </template>
              <template v-if="consultationCustomField.type == 'Select'">
<!--                <v-select :options="consultationCustomField.options" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="consultationFormData.custom_fields_form_data[key].value" class="md:mb-0" />-->
                <select v-model="consultationFormData.custom_fields_form_data[key].value" class="vs-inputx vs-input--input normal md:mb-0">
                  <option value="">{{ $t('please_select') }}</option>
                  <option v-for="(option, key) in consultationCustomField.options" :key="'consultation_custom_fields_' + key" :value="option.value">{{ option.label }}</option>
                </select>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row align-center mb-3">
        <div class="vx-col sm:w-2/12 w-full">
          <strong v-text="$t('consulting_title')"></strong>
        </div>
        <div class="vx-col sm:w-10/12 w-full">
          <vs-input v-model="consultationFormData.title" class="w-full"/>
          <validation-error :model-error="consultationFormErrors.title"></validation-error>
        </div>
      </div>
      <div class="vx-row align-center mb-3">
        <div class="vx-col sm:w-2/12 w-full">
          <strong v-text="$t('consultation_contents')"></strong>
        </div>
        <div class="vx-col sm:w-10/12 w-full">
          <vs-textarea class="mb-0" v-model="consultationFormData.content" />
          <validation-error :model-error="consultationFormErrors.content"></validation-error>
        </div>
      </div>
    </div>

    <!-- More History Section -->
    <div class="vs-collapse-item--header pointer mt-5" :class="{ 'mb-20': hideSection.moreHistory }" @click="toggleSection('more-history')">
      <div class="flex items-center">
        <feather-icon icon="ListIcon" class="mr-2" svgClasses="stroke-current text-white w-5 h-5" />
        <strong class="text-white" v-text="$t('more_history')"></strong>
      </div>
      <span class="icon-header vs-collapse-item--icon-header" :class="{ 'rotate-arrow-up': !hideSection.moreHistory }">
          <i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i>
        </span>
    </div>
    <div class="p-4 mb-20" :class="['show', { 'hide-section': hideSection.moreHistory }]">
      <vs-table hover-flat v-if="consultationHistory && consultationHistory.length" :data="consultationHistory">
        <template slot="thead">
          <vs-th v-text="$t('no')"></vs-th>
          <vs-th v-text="$t('inquiry')"></vs-th>
          <vs-th v-text="$t('status')"></vs-th>
          <vs-th v-text="$t('join_now')"></vs-th>
          <vs-th v-text="$t('subscription_time')"></vs-th>
          <vs-th v-text="$t('consulting_title')"></vs-th>
          <vs-th v-text="$t('consultation_contents')"></vs-th>
          <vs-th class="text-center" v-text="$t('record_file')"></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="key" v-for="(tr, key) in data">
            <vs-td v-text="tr.count"></vs-td>
            <vs-td v-text="tr.division ? tr.division.name : ''"></vs-td>
            <vs-td v-html="getResult(tr.result_type)"></vs-td>
            <vs-td v-text="$momentHelper.getDate(tr.created_at)"></vs-td>
            <vs-td v-text="$momentHelper.getTime(tr.created_at)"></vs-td>
            <vs-td>
              <a href="#" v-text="tr.title" @click.prevent="openViewConsultationPopup(tr.member.id, tr.id)"></a>
            </vs-td>
            <vs-td v-text="tr.content"></vs-td>
            <vs-td class="text-center">
              <div class="flex justify-center">
                <vs-button
                  color="primary"
                  type="border"
                  size="small"
                  icon-pack="feather"
                  icon="icon-play"
                  @click.prevent="playRecording($route.query.phone_no, tr.unique_id)"></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
        <div>No Record</div>
      </vs-alert>
    </div>

    <div class="actions flex content-center items-center">
      <vs-button class="m-2" color="danger" type="filled" icon-pack="feather" icon="icon-phone-off" @click.prevent="hangup">{{ $t('hangup') }}</vs-button>
      <vs-button v-if="false" class="m-2" color="warning" type="filled" icon-pack="feather" icon="icon-volume-2" @click.prevent="playSound">{{ $t('playsound') }}</vs-button>
      <vs-button class="m-2" color="success" type="filled" icon-pack="feather" icon="icon-phone-call" @click.prevent="answer">{{ $t('answer') }}</vs-button>
      <vs-button class="m-2" color="primary" type="filled" @click.prevent="startRecording" v-if="isRecording == false">{{ $t('start_recording') }}</vs-button>
      <vs-button class="m-2" color="danger" type="filled" @click.prevent="stopRecording" v-if="isRecording == true">{{ $t('stop_recording') }}</vs-button>
    </div>
  </div>
</template>

<script>
import Cti from '@/models/Cti'
import Big from '@/models/Big'
import Consultation from '@/models/Consultation'
import ctiWindow from '@/helpers/ctiWindow'
import Utils from '@/helpers/utils'
import announcementSocket  from '@/libs/sockets/announcements'

export default {
  name: 'Window.Inbound',
  data () {
    return {
      hideSection: {
        inboundInfo: false,
        profile: false,
        councelingManagement: false,
        moreHistory: false
      },
      ctiPopUp: 'window',
      inboundInfo: null,
      memberFormData: null,
      consultationFormData: null,

      memberFormErrors: {},
      consultationFormErrors: {},

      groupOptions : [],
      levelOptions : [],
      divisionOptions : [],
      resultOptions : [],
      bigOptions : [],
      smallOptions : [],
      extensionOptions : [],

      memberCustomFields: [],
      consultationCustomFields: [],
      consultationHistory: {},
      isRecording: false,
      companyId: null,
      memberId: null
    }
  },
  computed: {
    server () {
      return this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.servers : {}
    }
  },
  watch: {
    'consultationFormData.big_type_id' () {
      this.getSmallList()
    }
  },
  async mounted () {
    announcementSocket.setNode(this.server)
    await this.initData()
  },
  methods: {
    toggleSection (section) {
      if (section === 'inbound-info') {
        // this.hideSection.inboundInfo = (this.hideSection.inboundInfo === true) ? false : true
        this.hideSection.inboundInfo = !this.hideSection.inboundInfo
      } else if (section === 'profile') {
        // this.hideSection.profile = (this.hideSection.profile === true) ? false : true
        this.hideSection.profile = !this.hideSection.profile
      } else if (section === 'counceling-management') {
        // this.hideSection.councelingManagement = (this.hideSection.councelingManagement === true) ? false : true
        this.hideSection.councelingManagement = !this.hideSection.councelingManagement
      } else if (section === 'more-history') {
        // this.hideSection.moreHistory = (this.hideSection.moreHistory === true) ? false : true
        this.hideSection.moreHistory = !this.hideSection.moreHistory
      }
    },
    async initData () {
      const response = await Cti.showCall(this.$route.query)

      this.inboundInfo = response.data.data.inboundInfo
      this.memberFormData = response.data.data.memberFormData
      this.consultationFormData = {
        ...response.data.data.consultationFormData,
        assigned_agent_id: '',
        result_type_id: '',
        division_id: '',
        big_type_id: '',
        small_type_id: '',
        title: '',
        content: '',
        alarm: false
      }
      this.companyId = response.data.meta.companyId
      this.memberId = response.data.meta.memberId
      this.fetchHistory()
      this.memberCustomFields = response.data.meta.memberCustomFields
      this.consultationCustomFields = response.data.meta.consultationCustomFields

      this.groupOptions = response.data.meta.options.groups
      this.levelOptions = response.data.meta.options.levels
      this.divisionOptions = response.data.meta.options.divisions
      this.resultOptions = response.data.meta.options.results
      this.bigOptions = response.data.meta.options.bigs
      this.smallOptions = response.data.meta.options.smalls
      this.extensionOptions = response.data.meta.options.extensions

      // Set Defaults
      this.memberFormData.level_id = this.memberFormData.level_id === '' ? (this.levelOptions.length > 0 ? this.levelOptions[0].value : '') : this.memberFormData.level_id
      this.memberFormData.group_id = this.memberFormData.group_id === '' ? (this.groupOptions.length > 0 ? this.groupOptions[0].value : '') : this.memberFormData.group_id

      if (response.data.meta.companyId === 84) {
        this.consultationFormData.result_type_id = this.resultOptions.length > 0 ? this.resultOptions[0].value : ''
      } else {
        this.consultationFormData.result_type_id = this.resultOptions.length > 0 ? this.resultOptions[1].value : ''
      }
      this.consultationFormData.division_id = this.divisionOptions.length > 0 ? this.divisionOptions[0].value : ''
      this.consultationFormData.big_type_id = this.bigOptions.length > 0 ? this.bigOptions[0].value : ''
      this.consultationFormData.assigned_agent_id = this.extensionOptions.some(obj => obj.value === this.$store.getters.userInfo.id) ? this.$store.getters.userInfo.id : ''

    },
    async fetchHistory () {
      const response = await Cti.history({companyId: this.companyId, memberId: this.memberId})
      this.consultationHistory = response.data
    },
    answer () {
      Cti.answer(this.server.domain, { channel: this.$route.query.chanel, ext_no: this.$store.getters.extension })
    },
    playSound () {
      Cti.playSound(this.server.domain, this.$route.query.chanel)
    },
    startRecording () {
      this.isRecording = true
      Cti.oneTouchRecording(this.server.domain, { channel: this.$route.query.chanel, ext: this.$store.getters.extension, file: this.$route.query.recordingfile, action: 'start' })
    },
    stopRecording () {
      this.isRecording = false
      Cti.oneTouchRecording(this.server.domain, { channel: this.$route.query.chanel, ext: this.$store.getters.extension, action: 'stop' })
    },
    hangup () {
      Cti.hangup(this.server.domain, this.$route.query.chanel)
    },
    async getSmallList () {
      try {
        const response = await Big.getSmalls({ id: this.consultationFormData.big_type_id })
        this.smallOptions = []

        for (const small in response.data.smalls) {
          this.smallOptions.push({
            label: response.data.smalls[small],
            value: small
          })
        }

        this.consultationFormData.small_type_id = typeof this.smallOptions[0] !== 'undefined' ? this.smallOptions[0].value : ''
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
    },
    getResult (status) {
      switch (status.id) {
      case 1:
        return `<span class="text-info">${status.name}</span>`
      case 2:
        return `<span class="text-success">${status.name}</span>`
      case 3:
        return `<span class="text-secondary">${status.name}</span>`
      case 4:
        return `<span class="text-danger">${status.name}</span>`
      }
    },
    playRecording (src, uniqueId) {
      ctiWindow.consultationRecordingFile(src, uniqueId)
    },
    openViewConsultationPopup (memberId, consultationId) {
      Utils.openPopUp(this.ctiPopUp, 'edit-consultation', { id: memberId, consultationId })
    },
    openOutboundHistoryPopup () {
      Utils.openPopUp(this.ctiPopUp, 'outbound-history', { id: this.callerForm.member_id })
    },
    openSoundFilesPopup (extension) {
      Utils.openPopUp(this.ctiPopUp, 'open-sound-files', { extension })
    },
    async register () {
      try {
        await Consultation.store({
          memberFormData: this.memberFormData,
          consultationFormData: this.consultationFormData
        })
        if (typeof this.$route.query.open !== 'undefined' && this.$route.query.open === 'directly') {
          this.initData()
          this.$swalHelper.success({
            title: this.$t('time_conditions_save_success'),
            confirmButton: this.$t('confirm')
          })
        } else {
          announcementSocket.getSocket().emit('init_message_management_count')
          // this.$windowOpenerHelper.notifyOpener('close_inbound_select_member')
          if (window.opener && window.opener.$storeInboundOrOutboundPopup) {
            window.opener.$storeInboundOrOutboundPopup()
          }
          window.close()
        }

      } catch (e) {
        // TODO: Add custom error check when memberFormData has validation.
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.consultationFormErrors = errors.validationErrors
      }
    }
  }
}
</script>

<style lang="scss">
  #inboundContainer {
    padding-bottom: 50px;

    .vs-collapse-item--header {
      background-color: #667c8a;
      padding: 8px;
    }

    .actions {
      z-index: 999;
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      justify-content: center;
      align-items: center;
      background-color: #eee;
    }
  }
</style>
